<template>
  <div>
    <div class="form-row">
      <div class='row'>
        <div class='col-10'>
          <!--<div v-if="playVideoFlag==false">-->
            <img style="display:none;" id="bigpic" src="bigpic" class="car-image"/>
          <!--</div>-->
          <!--<video-player v-else class="video-player-box"
            ref="videoPlayer"
            :options="playerOptions"
            :playsinline="true"
            customEventName="customstatechangedeventname"
            @play="onPlayerPlay($event)"
            @pause="onPlayerPause($event)"
            @statechanged="playerStateChanged($event)"
            @ready="playerReadied">
          </video-player>-->
        </div>
        <!--<div class='col-2' v-if='img_string=="關閉照片"'>
            <h3> <kbd>車別 </kbd></h3>
            <div class="custom-control custom-radio">
              <input v-model="carName" type="radio" class="custom-control-input" id="defaultGroupExample1" value="小型車">
              <label class="custom-control-label" for="defaultGroupExample1"><h5>小型車</h5></label>
            </div>
            <div class="custom-control custom-radio">
              <input v-model="carName" type="radio" class="custom-control-input" id="defaultGroupExample2" value="摩托車">
              <label class="custom-control-label" for="defaultGroupExample2"><h5>摩托車</h5></label>
            </div>
            <div class="custom-control custom-radio">
              <input v-model="carName" type="radio" class="custom-control-input" id="defaultGroupExample3" value="重型機車">
              <label class="custom-control-label" for="defaultGroupExample3"><h5>重型機車</h5></label>
            </div>
            <div class="custom-control custom-radio">
              <input v-model="carName" type="radio" class="custom-control-input" id="defaultGroupExample4" value="其它">
              <label class="custom-control-label" for="defaultGroupExample4"><h5>其它</h5></label>
            </div>
            <button class="btn btn-primary" @click="updateCarName">更新</button>
        </div>-->
        
      </div>
      <button class="btn btn-primary" @click="showImg">{{img_string}}</button>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button class="btn btn-danger" @click="returnModify" :disabled="this.$store.state.user.user.username=='estcheck'">退回修正</button>
      <!--&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button class="btn btn-info" @click="uncertain">無法開單</button>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button class="btn btn-success" @click="pass">未違規</button>-->
      <!--&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button class="btn btn-dark" @click="playVideo">{{playVideoMsg}}</button>-->
    </div>
  </div>
</template>

<script>
import server from '@/config';
//import 'video.js/dist/video-js.css'
//import VueVideoPlayer from 'vue-video-player'
import Vue from 'vue'

//Vue.use(VueVideoPlayer)

export default {
  name: 'confirmShoulderCheckDetail',
  data() {
    return {
      status: null,
      sourceOfPicture: '',
      img_string: '顯示照片',
      //carName: '',
      randomNum: '',
      /*
      playerOptions: {
          // videojs options
          muted: true,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          autoplay: true,
          width: 800,
          sources: [{
            type: "video/mp4",
            src: "",
          }],
      },
      playVideoFlag: false,
      playVideoMsg: "撥放影片",
      sourceOfVideo: '',
      */
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
  },
  components: {
  },
  async mounted() {
    var img = document.getElementById('bigpic')
    this.randomNum = Math.random();
    this.sourceOfPicture = `/media/shoulder/done/${this.rowData.fixed_link_code.fixed_link_code}/${this.rowData.img_filename}?t=${this.randomNum}`;
    this.img_string="關閉照片";
    img.src = this.sourceOfPicture;
    img.style.display = "block";
    img.class="car-image";  
    //////
    /*
    var newFilename = this.rowData.img_filename.replace('jpg', 'mp4'); 
    console.log('newFilename:', newFilename);
    this.sourceOfVideo = `/media/shoulder/done/${this.rowData.fixed_link_code.fixed_link_code}/${newFilename}`;
    console.log('sourceOfVideo:',this.sourceOfVideo);
    this.playerOptions.sources[0].src=this.sourceOfVideo;
    */
    ////////
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  methods: {
    /*
    playVideo() {  
      if(this.playVideoMsg=="撥放影片") {
        console.log('1');
        var img = document.getElementById('bigpic')
        this.img_string="顯示照片";
        img.style.display = "none";  
        this.playVideoMsg="結束撥放";
        this.playVideoFlag = true;      
      }
      else {
        console.log('2'); 
        this.playVideoMsg="撥放影片";
        this.playVideoFlag = false;          
      }
    },
    // listen event
    onPlayerPlay(player) {
      // console.log('player play!', player)
    },
    onPlayerPause(player) {
      // console.log('player pause!', player)
    },
    // ...player event

    // or listen state event
    playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },

    // player is ready
    playerReadied(player) {
      console.log('the player is readied', player)
      // you can use it to do something...
      // player.[methods]
    },
    */
    showImg() {
      var img = document.getElementById('bigpic')
      this.randomNum = Math.random();
      this.sourceOfPicture = `/media/shoulder/done/${this.rowData.fixed_link_code.fixed_link_code}/${this.rowData.img_filename}?t=${this.randomNum}`;
      console.log(this.sourceOfPicture)
      if(img.style.display=="none")
      {
        this.img_string="關閉照片";
        img.src = this.sourceOfPicture;
        img.style.display = "block";
        img.class="car-image";
      }
      else
      {
        this.img_string="顯示照片";
        img.style.display = "none";
      }
    },
    returnModify() {
      this.instance.patch(`/api/shoulder-data/${this.rowData.id}/`, {
        xactno: this.rowData.xactno,
        status: "t0",
      })
      .then(() => {
        /*this.$parent.refresh();
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功, 已退回',
        });*/
        this.$parent.refresh();
      })
      .catch((err) => {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data,
        });
      });
    },
  },
};
</script>

<style lang="sass">
.car-image
  width: 100%
</style>



// WEBPACK FOOTER //
// ConfirmShoulderCheckDetail.vue?78cb0c65